define([
    'text!fnjinews2021/component/time-axis.html',
    'common/api',
    'jquery',
    'common/utils',

    'WebmCommon/utils',
    'fnjinews2021/component/swiper-time',

    'css!fnjinews2021/component/time-axis.css'

], function(
    tpl,Api,$,Utils,UtilsCommon,SwiperTime
){
    return {
        template: tpl,
        props: {
            FnjinewsInfo: Array
        },
        data: function(){
            return {
                fnjinewsImg: [
                    'https://static.fnji.com/view-v2/web/site/high-end-line/image/fnjinews_slick1.png?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1',
                    'https://static.fnji.com/view-v2/web/site/high-end-line/image/fnjinews_slick2.png?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1',
                    'https://static.fnji.com/view-v2/web/site/high-end-line/image/fnjinews_slick3.png?imageMogr2/thumbnail/2048x%3E/quality/100!/sharpen/1'
                ],
                years: [],

                currYear:2020,
                isZh: true,
                photo: 4,
                moreClickShow: true,
                windowWidth: 1440
            };
        },
        components: {
            SwiperTime: SwiperTime
        },
        computed: {

        },
        created: function () {
            var obj = this;
            obj.windowWidth = $(window).width();
        },
        methods: {
            init:function () {

            },

            locale: function(){
                var _this = this;
                if(_this.$i18n.locale=='en'){
                    _this.isZh = false;
                }else {
                    _this.isZh = true;
                }
            }
        },
        watch: {
            '$i18n.locale': function () {
                this.locale();
                console.log(11111111111);
            }
        },
        mounted: function(){
            this.locale();
            this.init();
        }
    };
});



//////////////////
// WEBPACK FOOTER
// ./fnjinews2021/component/time-axis.js
// module id = 129
// module chunks = 0